// @owners { team: patients }
import { type Brand } from '@alto/design-system';

type Images = typeof import('./index').images;

export async function loadImages(brand: Brand): Promise<Images> {
  switch (brand) {
    case 'fuzehealth':
      // webpack: /* webpackChunkName: "images-fuzehealth" */
      return (await import('./fuzehealth')).images;
    case 'fuzerx':
      // webpack: /* webpackChunkName: "images-fuzerx" */
      return (await import('./fuzerx')).images;
    case 'alto':
    default:
      // webpack: /* webpackChunkName: "images-alto" */
      return (await import('./index')).images;
  }
}

// This module only bundles for web — getImage.native.ts is preferred on native.
// Populated by setImages() once loadImages() resolves; empty until then.
let IMAGES = {} as Images;
export const setImages = (images: Images) => {
  IMAGES = images;
};

export const getImage = (imageName: keyof Images) => {
  return IMAGES[imageName];
};
